// Utils and constants for the DiversityComposition component.

export const KEY_MAP = {
    "Gender": "gender",
    "Ethnicity": "ethnicity",
    "Sexual Orientation": "sexual_orientation",
    "Disability": "disability",
}
